module.exports = __webpack_public_path__ + "static/media/offline_notice.6e1d3d77.png";